import { Button, type ButtonProps } from '@nespresso-design-system/components';
import { useCallback } from 'preact/hooks';
import type { Product } from '@/domain/Product.ts';
import type { Translations } from '@/domain/WidgetConfig.ts';
import useTranslations from '@/widgets/hooks/useTranslations.tsx';
import type { PersistedState } from '../../../../../Store.ts';
import styles from './ViewAlternatives.module.scss';
import useQueryStringStore from '@/widgets/hooks/useQueryStringStore.tsx';
import useCardModalId from '@/widgets/ProductList/cards/hooks/useCardModalId.tsx';

export type ViewAlternativesProps = {
  productId: string;
  alternativeProducts: Product[];
};

export default function ViewAlternatives({
  productId,
  alternativeProducts
}: ViewAlternativesProps) {
  const { t } = useTranslations<Translations>();
  const [, setState] = useQueryStringStore<PersistedState>();
  const viewAlternativesModalId = useCardModalId<PersistedState['openModal']>(
    'view-alternatives-',
    productId
  );

  const showModal = useCallback(
    async (event: any) => {
      event.stopPropagation();
      event.preventDefault();
      setState({
        openModal: viewAlternativesModalId.value
      });
    },
    [alternativeProducts, setState, viewAlternativesModalId.value]
  );

  return (
    <Button
      type="button"
      className={styles.button}
      label={t('productList.cards.purchase.viewAlternatives')}
      onClick={showModal}
      icon="24/symbol/arrow-right"
      size={'small' as ButtonProps['size']}
      variant="outline"
      disabled={alternativeProducts.length === 0}
    />
  );
}
